module.exports = __webpack_public_path__ + "img/seccion1.5.402c99d1.png";